import React from "react";

export const GlyphRow: React.FC<{ color?: string; scale?: number }> = ({
  color = "currentColor",
  scale = 1,
}) => (
  <svg
    viewBox="0 0 200 26"
    width={180 * scale}
    height={24 * scale}
    fill="none"
    stroke={color}
    strokeWidth="1.5"
    strokeLinecap="round"
    aria-hidden
  >
    {Array.from({ length: 7 }).map((_, i) => (
      <line key={i} x1={4 + i * 6} y1="6" x2={4 + i * 6} y2="22" />
    ))}
    <path d="M52 18 l4 -6 l4 6 l4 -6 l4 6" />
    <path
      d="M78 18 c 2 -4 6 -6 10 -5 c 3 1 5 3 7 2 c 2 -1 2 -4 4 -4"
      fill="none"
    />
    <circle cx="101" cy="11" r="1.2" fill={color} />
    <circle cx="120" cy="15" r="4" />
    <line x1="134" y1="7" x2="134" y2="22" />
    <path d="M148 8 a6 6 0 0 0 0 12" />
    <path d="M162 16 q3 -5 6 0 t6 0 t6 0" />
  </svg>
);

export const OrnRule: React.FC<{ color?: string; className?: string }> = ({
  color = "currentColor",
  className = "",
}) => (
  <div className={`flex items-center gap-3 ${className}`} style={{ color }}>
    <span className="flex-1 h-px" style={{ background: color, opacity: 0.35 }} />
    <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden>
      <rect x="5" y="0" width="0.8" height="10" transform="rotate(45 5 5)" fill={color} />
    </svg>
    <span className="flex-1 h-px" style={{ background: color, opacity: 0.35 }} />
  </div>
);

export const EyeMark: React.FC<{ color?: string; size?: number }> = ({
  color = "currentColor",
  size = 26,
}) => (
  <svg
    width={size}
    height={size * 0.6}
    viewBox="0 0 44 26"
    fill="none"
    stroke={color}
    strokeWidth="1.4"
    aria-hidden
  >
    <path d="M2 14 C 10 4, 34 4, 42 14 C 34 22, 10 22, 2 14 Z" />
    <circle cx="22" cy="14" r="3" fill={color} />
    <path d="M22 22 q2 4 -2 4" strokeLinecap="round" />
  </svg>
);

export const CornerOrn: React.FC<{ color?: string; flip?: boolean }> = ({
  color = "currentColor",
  flip = false,
}) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    stroke={color}
    strokeWidth="1"
    style={{ transform: flip ? "scaleX(-1)" : "none" }}
    aria-hidden
  >
    <path d="M4 60 L4 20 Q4 4 20 4 L60 4" />
    <path d="M10 60 L10 26 Q10 10 26 10 L60 10" opacity=".5" />
    <circle cx="20" cy="20" r="1.5" fill={color} />
  </svg>
);
